const circlesActionTypes = {
  FETCH_PENDING_CLOSED_CIRCLES: 'FETCH_PENDING_CLOSED_CIRCLES',
  FETCH_PENDING_CLOSED_CIRCLES_SUCCESS: 'FETCH_PENDING_CLOSED_CIRCLES_SUCCESS',
  FETCH_PENDING_CLOSED_CIRCLES_FAIL: 'FETCH_PENDING_CLOSED_CIRCLES_FAIL',

  FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION: 'FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION',
  FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION_SUCCESS: 'FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION_SUCCESS',
  FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION_FAIL: 'FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION_FAIL',
};

export default circlesActionTypes;
